<template>
    <div class="index-box">
        <div class="index-slogan">
            <!-- <img src="@/pc/images/hei.png" width="30%" alt=""> -->
            <p>嘿，加入平行线</p>
            <p>你就能和我们一样帅</p>
            <Button type="primary" shape="circle" @click="goto('campus')">申请职位</Button>
            <!--<Button type="primary" shape="circle" @click="showModal = true">申请职位</Button>-->
            <!--<Modal :closable="false" v-model='showModal'>-->
                <!--<div class="index-sort" @click="goto('campus')">                    -->
                        <!--<img src="@/pc/images/freshgra.png">-->
                        <!--<p>校园招聘</p>           -->
                <!--</div>                -->
                 <!--<div class="index-sort" @click="goto('social')">  -->
                        <!--<img src="@/pc/images/exper.png">    -->
                        <!--<p>社会招聘</p>            -->
                <!--</div>                -->
               <!--<div style="clear:both;"></div>-->
            <!--</Modal>-->
        </div>
        <img src="@/pc/images/indexbg.png" class="banner-img">
        <div style="clear:both;"></div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data () {
            return {
                showModal: false
            }
        },
        methods:{
            goto(name){
                this.showModal=false;
                this.$router.push({name:name})
            }
        }
    }
</script>
<style scoped>
    .index-box{
        min-height: 93.5vh;
        padding-left: 17%;
        padding-bottom: 110px;
    }
</style>
<style>

.index-slogan{
    font-size: 3.5rem;
    color:#359567;
    position: absolute;
    padding-top: 25vh;
}
.index-slogan p:nth-child(2){
    font-weight: 600;
}
.banner-img{
    width: 48%;
    float:right;
    margin-top: -60px;
}
.index-box Button{
    font-family: '微软雅黑';
    font-size: 1.1rem;
    padding: 10px 50px;
    box-shadow: 0px 10px 10px -10px  rgba(53, 147, 102, .8);
}
/* 弹窗样式 */
.ivu-modal-mask{
    background-color: rgba(255, 255, 255, 0.6)
}
.ivu-modal{
    box-shadow: 0px 0px 200px 0px #e5e5e5;
    top: 30vh;
}
.ivu-modal-body{
    padding: 6vh 0;
}
.ivu-modal-body .index-sort{
    float: left;
    width: 50%;
    text-align: center;
    cursor: pointer;
}
.ivu-modal-body .index-sort:nth-of-type(1){
    border-right: 1px solid #f2f3f5;
}
.ivu-modal-body .index-sort p{
    color: #359567;
    font-size: 1.2rem;
    margin-top: 2vh;
}
.ivu-modal-footer{
    display: none;
}
</style>
